import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

const cpfMask = '000.000.000-00';
const cnpjMask = '00.000.000/0000-00';
const cpfLength = 11;

@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.css'],
  standalone: false,
})
export class LeadFormComponent implements OnChanges, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() privacyPolicy!: string;

  @Input() allowNaturalPerson = false;
  @Input() allowLegalPerson = false;

  documentLabelKey: 'cpf' | 'cnpj' | 'cpfOrCnpj' = 'cpf';
  documentMask = '';

  private documentSub?: Subscription;

  constructor(private readonly translate: TranslateService) {}

  get documentLabel(): string {
    return this.translate.instant(
      'features.onboarding.leadForm.labels.' + this.documentLabelKey,
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formGroup'] && this.formGroup) {
      this.documentSub?.unsubscribe();

      const documentControl = this.formGroup.get('document');
      if (documentControl) {
        this.setInitialDocumentConfig();
        this.updateDocumentType(documentControl.value);

        this.documentSub = documentControl.valueChanges.subscribe(value => {
          this.updateDocumentType(value);
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.documentSub?.unsubscribe();
  }

  private setInitialDocumentConfig(): void {
    if (this.allowNaturalPerson && !this.allowLegalPerson) {
      this.documentLabelKey = 'cpf';
      this.documentMask = cpfMask;
      return;
    }

    if (!this.allowNaturalPerson && this.allowLegalPerson) {
      this.documentLabelKey = 'cnpj';
      this.documentMask = cnpjMask;
      return;
    }

    this.documentLabelKey = 'cpfOrCnpj';
    this.documentMask = '';
  }

  private updateDocumentType(value: string | null | undefined): void {
    const digits = (value ?? '').replace(/\D/g, '');

    if (this.allowLegalPerson && !this.allowNaturalPerson) {
      this.documentLabelKey = 'cnpj';
      this.documentMask = cnpjMask;
      return;
    }

    if (this.allowNaturalPerson && !this.allowLegalPerson) {
      this.documentLabelKey = 'cpf';
      this.documentMask = cpfMask;
      return;
    }

    if (digits.length > cpfLength) {
      this.documentLabelKey = 'cnpj';
      this.documentMask = cnpjMask;
    } else if (digits.length > 0) {
      this.documentLabelKey = 'cpf';
      this.documentMask = cpfMask;
    } else {
      this.documentLabelKey = 'cpfOrCnpj';
      this.documentMask = '';
    }
  }
}
